import React, { useState } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import {
    PageContainer,
    HR,
    DesktopView,
    PaginationContainer,
    MobileView,
    PaginationContainerMobile,
    AdminListContainer,
} from './index.styled';
import BasicPagination from 'src/common/refactoredComponents/paginator';
import AdminHeader from './adminHeader';
import AdminSearchResult from 'src/pages/admin/search/adminSearchResult.jsx';
import AdminList from 'src/pages/admin/adminList';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import Backdrop from 'src/common/refactoredComponents/backdrop/Backdrop';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import {
    setAdminSearchOpen,
    setAdminFilterOpen,
    setAdminFilterParamValues,
    setFilterPage,
    getAdminAccountDetails,
    getAdminUserList,
    resetRoles,
    resetTerritory,
    setAdminFilters,
    setShowLocalExpandedView,
    setAppliedFilter,
    setAdminFilterParams,
    getFilterData,
    getFilterDetails,
    setFilterAfterImpersonation,
    clearAdminFilters,
    setImpersonationStatus,
    setSelectedSalesOrg,
    setSalesOrgInitialized
} from 'src/pages/admin/redux/action';
import { setSelectedViews } from 'src/pages/admin/redux/action';
import { checkImpersonationActive, checkProxyActive } from 'src/utils/util';
import { setActiveNavLink } from 'src/pages/home/redux/actions';
import { getProxyList } from 'src/pages/more/pages/proxies/redux/action/index.js';
import {
    CC_USER_ROLE,
    ITA_USER_ROLE,
    FIM_USER_ROLE,
    pageNames,
} from 'src/constants/appConstants';
import { useDynatracePageName } from 'src/common/hooks/useDynatracePageName';

const ProxiesContainer = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [page, setPage] = useState(0);
    const [first, setFirst] = useState(0);
    const [adminSortParam, setAdminSortParam] = useState('');
    const [searchParamValues, setSearchParamValues] = useState('');
    const [searchValue, setSearchValue] = useState('');
    const [isFilterUpdated,setIsFilterUpdated] = useState(false);
    const filterPage = useSelector((state) => state.AdminReducer.filterPage);

    const updateUserStatus = useSelector(
        (state) => state.AdminReducer.updateUserStatus
    );
    const initiateProxyStatus = useSelector(
        (state) => state.AdminProxyReducer.initiateProxyStatus
    );
    const impersonationStatus = useSelector(
        (state) => state.AdminProxyReducer.impersonationStatus
    );
    const { isFiltersCleared } = useSelector((state) => ({
        isFiltersCleared: state.AdminFilterReducer.isFiltersCleared,
    }));
    const { selectedSalesOrg, saleOrgView, selectedView } = useSelector(
        (state) => ({
            selectedSalesOrg: state.AdminReducer.selectedSalesOrgView,
            saleOrgView: state.AdminReducer.adminUser?.salesOrgFilter,
            selectedView: state.AdminReducer.selectedViews,
        })
    );
    const adminFilterParamValues = useSelector(
        (state) => state.AdminReducer.adminFilterParamValues
    );
    const adminImperonationEndStatus = useSelector(
        (state) => state.AdminProxyReducer.terminationStatusCode
    );
    const isSalesOrgInitialized = useSelector((state) => state.AdminProxyReducer.isSalesOrgInitialized);
    // useEffectWithErrorLogging(() => {
    //     if (adminImperonationEndStatus === '200') {
    //         window.location.reload(true);
    //     }
    // }, [adminImperonationEndStatus]);

    useDynatracePageName(pageNames.admin);
    useEffectWithErrorLogging(() => {
        dispatch(getProxyList());
        if (sessionStorage.getItem('isRedirectToWCMS')) {
            // const selectedArray = JSON.parse(
            //     sessionStorage.getItem('selectedViews')
            // );
            // dispatch(setSelectedViews(selectedArray));
            // const appliedView = JSON.parse(
            //     sessionStorage.getItem('appliedData')
            // );

            // appliedView && dispatch(setAppliedFilter(appliedView));
            // var param = JSON.parse(sessionStorage.getItem('param')); //no brackets
            // var value = JSON.parse(sessionStorage.getItem('value')); //no brackets
            // var salesOrg = JSON.parse(sessionStorage.getItem('salesOrg')); //no brackets
            // dispatch(
            //     getAdminUserList(param, '', value ? true : false, salesOrg)
            // );
            dispatch(getFilterData(true));
        }
        // var storedArray = JSON.parse(sessionStorage.getItem('items')); //no brackets
        // storedArray && dispatch(setFilterAppliedView(storedArray));
        // var storedSalesOrgArray = JSON.parse(
        //     sessionStorage.getItem('SalesOrgView')
        // ); //no brackets
        // storedSalesOrgArray &&
        //     dispatch(setSelectedSalesOrg(storedSalesOrgArray));
        // dispatch(getFilterData(sessionStorage.getItem('FilterDataOpen')));
    }, []);
    useEffectWithErrorLogging(() => {
        if (
            filterPage ||
            (initiateProxyStatus === '200' && impersonationStatus)
        ) {
            setPage(0);
            setFirst(0);
            dispatch(setImpersonationStatus());
        }
        dispatch(setFilterPage(false));
        const pageParam = { pageNum: page };
        let salesOrgsData = [];
        selectedSalesOrg &&
            selectedSalesOrg.map((item) => {
                if (item.isChecked) {
                    salesOrgsData.push(item.value);
                }
            });
        const param = {
            ...adminFilterParamValues,
            ...pageParam,
            ...adminSortParam,
            pageNum: adminFilterOpen || isFiltersCleared ? '' : page,
            salesOrgs: salesOrgsData ? salesOrgsData.join(',') : '',
        }; 
        if (
            !checkImpersonationActive() ||
            (checkImpersonationActive() &&
                (sessionStorage.getItem('ProxyUserRole') === CC_USER_ROLE ||
                    sessionStorage.getItem('ProxyUserRole') === ITA_USER_ROLE ||
                    sessionStorage.getItem('ProxyUserRole') === FIM_USER_ROLE))
        ) {
            dispatch(getAdminUserList(param, '', false, selectedSalesOrg));

            if (adminFilterOpen) {
                dispatch(setAdminFilterOpen(false));
                setFirst(pageParam.pageNum ? pageParam.pageNum : 0);
                setPage(0);
            }
        }
        // if (!isImpersonationActive) {
        //     // const storedArray = JSON.parse(sessionStorage.getItem('items')); //no brackets
        //     // storedArray && dispatch(setFilterAppliedView(storedArray));
        //     const selectedArray = JSON.parse(
        //         sessionStorage.getItem('selectedViews')
        //     ); //no brackets
        //     const selectedFilter = JSON.parse(
        //         sessionStorage.getItem('appliedData')
        //     ); //no brackets
        //     selectedFilter && dispatch(setAppliedFilter(selectedFilter));
        //     selectedArray && dispatch(setSelectedViews(selectedArray));
        //     let paramAfterImpersonation = JSON.parse(
        //         sessionStorage.getItem('param')
        //     );
        //     paramAfterImpersonation &&
        //         dispatch(getAdminUserList({...paramAfterImpersonation, ...pageParam}, '', false));
        //     dispatch(setFilterAfterImpersonation(false));
        // }
        dispatch(clearAdminFilters(false));
    }, [
        page,
        adminFilterParamValues,
        adminSortParam,
        updateUserStatus === '10802',
        initiateProxyStatus,
        isFilterUpdated
    ]);
    useEffectWithErrorLogging(() => {
        if (!isImpersonationActive) {
            // const storedArray = JSON.parse(sessionStorage.getItem('items')); //no brackets
            // storedArray && dispatch(setFilterAppliedView(storedArray));
            const selectedArray = JSON.parse(
                sessionStorage.getItem('selectedViews')
            ); //no brackets
            const selectedFilter = JSON.parse(
                sessionStorage.getItem('appliedData')
            ); //no brackets
            selectedFilter && dispatch(setAppliedFilter(selectedFilter));
            selectedArray && dispatch(setSelectedViews(selectedArray));
            selectedArray &&
                dispatch(setSelectedSalesOrg(selectedArray?.salesOrgView));
            let paramAfterImpersonation = JSON.parse(
                sessionStorage.getItem('param')
            );

            paramAfterImpersonation &&
                dispatch(
                    getAdminUserList(
                        paramAfterImpersonation,
                        '',
                        false,
                        selectedSalesOrg
                    )
                );

            dispatch(setFilterAfterImpersonation(false));
        }
        if (isImpersonationActive) {
            dispatch(
                setAppliedFilter({
                    appliedsalesOrgView: [],
                    appliedDistrict: {},
                    appliedTerritory: {},
                    appliedRole: {},
                })
            );
        }
    }, [checkImpersonationActive()]);
    const handleCloseSearch = () => {
        sessionStorage.removeItem('adminSearch');
        dispatch(setAdminSearchOpen(false));

        setSearchParamValues('');
        setSearchValue('');
    };
    useEffectWithErrorLogging(() => {
        dispatch(
            setActiveNavLink({
                dashboard: false,
                calendar: false,
                admin: true,
                orders: false,
                alerts: false,
                inventory: false,
                more: false,
                deniedUsageOverrides: false,
                productGuide: false,
            })
        );
    }, []);
    useEffectWithErrorLogging(() => {
        if (
            sessionStorage.getItem('adminSearch') &&
            !checkImpersonationActive()
        ) {
            dispatch(setAdminSearchOpen(true));
        } else {
            dispatch(setAdminSearchOpen(false));
        }
    }, [adminImperonationEndStatus]);

    useEffectWithErrorLogging(() => {
        dispatch(setAdminFilterOpen(false));
        setSearchParamValues('');
        // dispatch(getAdminUserList());
    }, []);

    // useEffectWithErrorLogging(() => {
    //     setSearchParamValues('');
    //     // setAccountFilterParamValues = '';
    //     // dispatch(setAccountFilterParamValues(''));
    //     // dispatch(getAccountDetails(page));
    //     // dispatch(getDistrict(true));
    //     // dispatch(getAccounts());
    //     if (sessionStorage.getItem('adminSearch')) {
    //         dispatch(setAdminSearchOpen(true));
    //     } else {
    //         dispatch(setAdminSearchOpen(false));
    //     }

    //     // dispatch(getFilterData(false));
    // }, []);

    const fromAdminSearch = useSelector(
        (state) => state.AdminReducer.fromAdminSearch
    );

    useEffectWithErrorLogging(() => {
        if (fromAdminSearch === true) {
            const pageParam = { pageNum: page };
            const param = {
                // ...accountSearchParamValues,
                ...adminFilterParamValues,
                ...pageParam,
                ...adminSortParam,
            }; 
            dispatch(getAdminAccountDetails(param));

            dispatch(getAdminUserList(param, '', false));
        }
    }, [fromAdminSearch]);
    useEffectWithErrorLogging(() => {
        if (isFiltersCleared) {
            setFirst(0);
            setPage(0);
        }
        dispatch(clearAdminFilters(false));
    }, [isFiltersCleared]);

    const onPageChange = (event) => {
        setFirst(event.first);
        setPage(event.page);
    };

    useEffectWithErrorLogging(()=>{
       if(isSalesOrgInitialized){
        return;
       }
       const isSalesOrgInitializedInLocal = localStorage.getItem('isSalesOrgInitializedInLocal');
       if(isSalesOrgInitializedInLocal){
        return;
       }
       if( saleOrgView && saleOrgView.length > 0 && !isImpersonationActive){
        let salesOrgViewDataDetails = saleOrgView &&
            saleOrgView.length > 0 && [...saleOrgView];
        salesOrgViewDataDetails &&
            salesOrgViewDataDetails.length > 0 &&
            salesOrgViewDataDetails.map((item) => {
                if (item.isDefault || item.isChecked) {
                    item.isChecked = true;
                } else {
                    item.isChecked = false;
                }
            });
        dispatch(
                setSelectedViews({
                    salesOrgView: salesOrgViewDataDetails,
                    districtView: { id: 'All District', name: 'All' },
                    territoryView: { id: 'All Territory', name: 'All' },
                    roleView: { id: 'All', name: 'All' },
                })
            );
            dispatch(setSelectedSalesOrg(salesOrgViewDataDetails));
            dispatch(setSalesOrgInitialized());
            localStorage.setItem('isSalesOrgInitializedInLocal', true);
        }
    },[saleOrgView]);
    

    const handleClick = () => {
        if (adminSearchOpen === false) dispatch(setAdminFilterOpen(true));
        let salesOrgViewDataDetails = saleOrgView &&
            saleOrgView.length > 0 && [...saleOrgView];
        salesOrgViewDataDetails &&
            salesOrgViewDataDetails.length > 0 &&
            salesOrgViewDataDetails.map((item) => {
                if (item.isChecked) {
                    item.isChecked = true;
                } else {
                    item.isChecked = false;
                }
            });
        dispatch(
            getFilterDetails({
                selectedView: {
                    salesOrgView: salesOrgViewDataDetails,
                    districtView: selectedView?.districtView,
                    territoryView: selectedView?.territoryView,
                    roleView: selectedView?.roleView,
                },
                filterType: 'salesOrg',
            })
        );
        setSearchValue('');
    };
    const handleClose = () => {
        // dispatch(setPopupCloseFromHeader(true));
        dispatch(setAdminFilterOpen(false));
        //dispatch(setSelectedSalesOrg(adminUser.salesOrgFilter));
        
        // Reset selectedViews to match the currently applied filters when closing via backdrop/outside click
        dispatch(
            setSelectedViews({
                salesOrgView: appliedView?.appliedsalesOrgView || saleOrgView,
                districtView: appliedView?.appliedDistrict?.id 
                    ? { ...appliedView.appliedDistrict }
                    : { id: 'All District', name: 'All' },
                territoryView: appliedView?.appliedTerritory?.id 
                    ? { ...appliedView.appliedTerritory }
                    : { id: 'All Territory', name: 'All' },
                roleView: appliedView?.appliedRole?.id 
                    ? { ...appliedView.appliedRole }
                    : { id: 'All', name: 'All' },
            })
        );
    };

    const handleSort = (sortParams) => {
        const param = {
            sortParam: sortParams.sortParam,
            sortOrder: sortParams.sortOrder,
        };
        setAdminSortParam(param);
        setFirst(0);
        setPage(0);
    };

    const adminSearchOpen = useSelector(
        (state) => state.AdminReducer.adminSearchOpen
    );

    const adminFilterOpen = useSelector(
        (state) => state.AdminReducer.adminFilterOpen
    );

    const totalResults = useSelector(
        (state) => state.AdminReducer.totalRecords
    );

    const { adminUserList } = useSelector((state) => ({
        adminUserList: state.AdminReducer.adminUserList,
    }));
    const loading = useSelector((state) => state.AdminReducer.loading);

    const { appliedView } = useSelector((state) => state.AdminReducer);

    const { filterDataOpen } = useSelector((state) => ({
        filterDataOpen: state.AdminReducer.filterDataOpen,
        // salesOrg: state.AdminReducer.salesOrg,
    }));

    const filterValuesArray =
        appliedView &&
        typeof appliedView === 'object' &&
        Object.keys(appliedView || {})
            .filter(
                (key) =>
                    appliedView[key] &&
                    appliedView[key].name &&
                    appliedView[key].name != 'All'
            )
            .map((key) => appliedView[key].name);

    const resetHandler = () => {
        resetAppliedView();
    };

    const resetAppliedView = () => {
        setSearchParamValues('');
        // setAccountFilterParamValues('');
        dispatch(setAdminFilterParamValues(''));
        // setAccountFilterParamValues = '';

        if (appliedView) {
            appliedView.appliedDistrict = {};
            appliedView.appliedTerritory = {};
            appliedView.appliedRole = {};
        }
        dispatch(setAdminFilters({}));
        dispatch(resetRoles());
        dispatch(resetTerritory());
        dispatch(setAdminFilterParams({}));

        dispatch(
            setShowLocalExpandedView({
                districtView: true,
                territoryView: false,
                roleView: false,
            })
        );
        // dispatch(
        //     setExpandedAccountViews({
        //         AccountView: false,
        //     })
        // );
        dispatch(
            setAppliedFilter({
                appliedsalesOrgView: [],
                appliedDistrict: {},
                appliedTerritory: {},
                appliedRole: {},
            })
        );
        if (!isImpersonationActive) {
            sessionStorage.removeItem('selectedViews');
            sessionStorage.removeItem('param');
            sessionStorage.removeItem('appliedData');
        }
    };
    // useEffectWithErrorLogging(() => {
    //     if (!adminFilterOpen) {
    //         const param = {
    //             isDefaultSalesOrg: true,
    //             sortParams: 'name',
    //             salesOrgs: salesOrg.filter((item) => item.isDefault).join(','),
    //         };
    //         // dispatch(getAdminUserList(param));
    //     }
    // }, [salesOrg]);

    // banner height manage

    const [showBanner, setShowBanner] = useState(false);

    const bannerInfo = useSelector(
        (state) => state.loginReducer.bannerInfo,
        shallowEqual
    );
    const isImpersonationActive = useSelector(
        (state) => state.impersonationReducer.isImpersonationActive
    );
    useEffectWithErrorLogging(() => {
        let userInfoMessages = [];
        if (bannerInfo) {
            userInfoMessages = bannerInfo.filter(
                (item) => item.messageType === 'userInfoMessage'
            );
        }
        if (userInfoMessages.length > 0) {
            setShowBanner(true);
        }
    }, []);

    const showSingleBanner =
        checkProxyActive() || isImpersonationActive || showBanner;
    const showDoubleBanner =
        (checkProxyActive() && showBanner) ||
        (isImpersonationActive && showBanner);

    return (
        <>
            <HR />
            <PageContainer
                adminSearchOpen={adminSearchOpen}
                filterDataOpen={filterDataOpen}
            >
                <AdminHeader
                    handleClick={handleClick}
                    handleClose={handleClose}
                    adminUserList={adminUserList}
                    totalResults={totalResults}
                    searchParamValues={searchParamValues}
                    setSearchParamValues={setSearchParamValues}
                    setAdminFilterParamValues={setAdminFilterParamValues}
                    adminFilterParamValues={adminFilterParamValues}
                />

                {adminSearchOpen && (
                    <AdminSearchResult
                        adminSearchOpen={adminSearchOpen}
                        filterDataOpen={filterDataOpen}
                        totalResults={adminUserList}
                        setSearchParamValues={setSearchParamValues}
                        searchParamValues={searchParamValues}
                        handleClose={handleCloseSearch}
                    />
                )}
                {/* {filterDataOpen && (
                    <ViewFilters
                        appliedFilters={filterValuesArray}
                        resetHandler={resetHandler}
                    />
                )} */}

                <AdminListContainer
                    adminSearchOpen={adminSearchOpen}
                    filterDataOpen={filterDataOpen}
                    showSingleBanner={showSingleBanner}
                    showDoubleBanner={showDoubleBanner}
                >
                    <AdminList
                        setIsFilterUpdated={setIsFilterUpdated}
                        isFilterUpdated={isFilterUpdated}
                        adminSearchOpen={adminSearchOpen}
                        filterDataOpen={filterDataOpen}
                        adminUserList={adminUserList}
                        handleSort={handleSort}
                        filterValuesArray={filterValuesArray}
                        resetHandler={resetHandler}
                        searchValue={searchValue}
                        setSearchValue={setSearchValue}
                        viewFilter={true}
                    />
                </AdminListContainer>
                {loading == false && adminUserList?.length > 0 && (
                    <DesktopView
                        showSingleBanner={showSingleBanner}
                        showDoubleBanner={showDoubleBanner}
                    >
                        <PaginationContainer>
                            <BasicPagination
                                totalRecords={totalResults}
                                recordsFetched={
                                    adminUserList && adminUserList.length
                                }
                                pageNumber={page}
                                handleChange={(e) => onPageChange(e)}
                                first={first}
                                // recordsPerPage={pageLimit}
                                // margin="12px 0px 12px 6px"
                                content={t(
                                    'orders.searchOrdersPanel.ShowingUsers'
                                )}
                                iPadPaginatorInfoWidth={'100%'}
                                iPadPaginatorWidth={'100%'}
                                linkPadding={'8px 0'}
                                linkMargin={'4px 0 12px 0'}
                                margin={'4px 0px 12px 0px'}
                                marginKB={'4px 0px 12px 0px'}
                            />
                        </PaginationContainer>
                    </DesktopView>
                )}
                {loading == false && adminUserList?.length > 0 && (
                    <MobileView>
                        <PaginationContainerMobile padding={'0'}>
                            <BasicPagination
                                totalRecords={
                                    (totalResults && totalResults) || 0
                                }
                                recordsFetched={
                                    adminUserList && adminUserList.length
                                }
                                pageNumber={page}
                                handleChange={(e) => onPageChange(e)}
                                first={first}
                                mobilePadding={'2% 2% 2% 2%'}
                                content={t(
                                    'orders.searchOrdersPanel.ShowingUsers'
                                )}
                            />
                        </PaginationContainerMobile>
                    </MobileView>
                )}
                {loading === true ? (
                    <Backdrop
                        showCloseButton={false}
                        showBackdrop={true}
                        isModal
                        loaderBackground
                    >
                        <Spinner
                            id="admin-index-admin-loadingSpinner"
                            animation="border"
                            variant="primary"
                            small
                        ></Spinner>
                    </Backdrop>
                ) : null}
            </PageContainer>
        </>
    );
};
export default ProxiesContainer;
